import * as React from "react";
import type { SVGProps } from "react";
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 12.108c0-5.557-4.477-10.061-10-10.061S2 6.55 2 12.108c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.909h2.54V9.891c0-2.521 1.492-3.914 3.777-3.914 1.094 0 2.238.196 2.238.196V8.65h-1.26c-1.243 0-1.63.776-1.63 1.572v1.887h2.773l-.443 2.908h-2.33v7.03C18.343 21.293 22 17.13 22 12.109"
    />
  </svg>
);
export default SvgFacebook;
